import angular from 'angular';

angular.module('app.core').factory('AuditAction', AuditAction);

export default class AuditAction {
    constructor(auditAction) {
        this.key = auditAction.key || null;
        this.parent = auditAction.parent || null;
        this.label = auditAction.label || null;
        this.display = auditAction.display || null;
    }

    getActionDisplay(audit) {
        if (this.display) {
            var mapParam = {
                param1: audit.param1,
                param2: audit.param2,
                param3: audit.param3,
                param4: audit.param4,
                param5: audit.param5,
                param6: audit.param6,
                param7: audit.param7,
                param8: audit.param8,
            };
            return this.display
                .replace(/param1|param2|param3|param4|param5|param6|param7|param8/gi, matched => mapParam[matched])
                .replace(/{{|}}/gi, '');
        }
        return this.display.key;
    }
}
